import { FC } from 'react';
import { Redirect, Route, Switch, useParams } from 'react-router-dom';
import RouteConstants from '@/features/router/RouteConstants';
import { useWhatsappInboxEnabled } from '@/features/whatsappInbox';
import { CampaignsWhatsappCreateFlowV2 } from '../components/CampaignsWhatsappCreateFlowV2';
import { CampaignsWhatsappEditFlowV2 } from '../components/CampaignsWhatsappEditFlowV2';
import { CampaignsInnerRoutePlaceholderV2 } from '../components/CampaignsInnerRoutePlaceholderV2';
import { CampaignsCreditPackagesSection } from '../components/CampaignsCreditPackagesSection';
import { WhatsappCampaignList } from './Campaigns/WhatsappCampaignList';
import { WhatsappCampaignDetails } from './Campaigns/WhatsappCampaignDetails/WhatsappCampaignDetails';
import { WhatsappCampaignInboxView } from './Inbox/WhatsappCampaignInboxView';
import { WhatsappTemplateList } from './Templates/WhatsappTemplateList';
import { WhatsappTemplateWorkaround } from './Templates/Workaround/WhatsappTemplateWorkaround';
import { WhatsappTemplateEditWorkaround } from './Templates/Workaround/WhatsappTemplateEditWorkaround';
import { WhatsappTemplateDeleteWorkaround } from './Templates/Workaround/WhatsappTemplateDeleteWorkaround';

const WhatsappTemplateDetailView: FC = () => {
  const { templateId } = useParams<{ templateId: string }>();
  return <CampaignsInnerRoutePlaceholderV2 title='WhatsApp template details' description={`Details view for template ${templateId}.`} />;
};

const WhatsappPackagesView: FC = () => <CampaignsCreditPackagesSection channel='whatsapp' />;

const WhatsappInboxRoute: FC = () => {
  const inboxEnabled = useWhatsappInboxEnabled();
  if (!inboxEnabled) {
    return <Redirect to={RouteConstants.whatsappCampaigns} />;
  }
  return <WhatsappCampaignInboxView />;
};

export const CampaignsWhatsappRoutesV2: FC = () => (
  <Switch>
    <Route exact path={RouteConstants.whatsappCampaigns} component={WhatsappCampaignList} />
    <Route exact path={RouteConstants.createCampaignWhatsapp} component={CampaignsWhatsappCreateFlowV2} />
    <Route exact path={RouteConstants.editCampaignWhatsapp} component={CampaignsWhatsappEditFlowV2} />
    <Route exact path={RouteConstants.whatsappCampaignDetails} component={WhatsappCampaignDetails} />

    <Route exact path={RouteConstants.whatsappTemplates} component={WhatsappTemplateList} />
    <Route exact path={RouteConstants.createWhatsappTemplate} component={WhatsappTemplateWorkaround} />
    <Route exact path={RouteConstants.whatsappTemplatesEditHub} component={WhatsappTemplateEditWorkaround} />
    <Route exact path={RouteConstants.whatsappTemplatesDeleteHub} component={WhatsappTemplateDeleteWorkaround} />
    <Route exact path={RouteConstants.whatsappTemplateDetails} component={WhatsappTemplateDetailView} />
    <Route exact path={RouteConstants.whatsappPackages} component={WhatsappPackagesView} />
    <Route exact path={RouteConstants.whatsappCampaignInbox} component={WhatsappInboxRoute} />
    <Route exact path={RouteConstants.whatsappCampaignInboxConversation} component={WhatsappInboxRoute} />

    <Route exact path={`${RouteConstants.campaigns}/whatsapp`}>
      <Redirect to={RouteConstants.whatsappCampaigns} />
    </Route>
  </Switch>
);
